import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  IconCalendarEvent,
  IconChartBar,
  IconLayoutKanban,
  IconListCheck,
  IconMedal,
  IconMessage,
  IconPhone,
  IconPlug,
  IconTag,
  IconTrendingUp,
  IconUser,
  IconUsersGroup,
  IconUsersPlus,
  IconPalette,
  IconBook,
  IconX,
} from '@tabler/icons-react';
import { useSidebar } from '../model/sidebarStore';

interface MainSidebarProps {
  isAdmin: boolean;
  isManager?: boolean;
}

const MainSidebar: React.FC<MainSidebarProps> = ({ isAdmin, isManager }) => {
  const canSeeAnalytics = isAdmin || isManager;
  const { isOpen, toggle } = useSidebar();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isActive = (path: string) => pathname === path;

  const handleItem = (path: string) => {
    navigate(path);
    if (window.innerWidth <= 1024) toggle();
  };

  const item = (path: string, icon: React.ReactNode, label: string) => (
    <button
      key={path}
      className={`main-sidebar-item${isActive(path) ? ' active' : ''}`}
      onClick={() => handleItem(path)}
      type="button"
      title={!isOpen ? label : undefined}
    >
      {icon}
      <span className="main-sidebar-label">{label}</span>
    </button>
  );

  return (
    <>
      <div className={`main-sidebar-overlay${isOpen ? ' visible' : ''}`} onClick={toggle} />
      <aside className={`main-sidebar${isOpen ? '' : ' collapsed'}`}>
        <button className="main-sidebar-close" type="button" onClick={toggle} aria-label="Закрыть меню">
          <IconX size={20} stroke={2} />
        </button>
        <nav className="main-sidebar-nav">
          {item('/kanban', <IconLayoutKanban size={21} stroke={2} />, 'Доска')}
          {item('/tasks', <IconCalendarEvent size={21} stroke={2} />, 'Задачи')}
          {item('/leader-board', <IconMedal size={21} stroke={2} />, 'Лидер борд')}
          {item('/knowledge-base', <IconBook size={21} stroke={2} />, 'База знаний')}
          {canSeeAnalytics && item('/analytics', <IconTrendingUp size={21} stroke={2} />, 'Аналитика')}
          {canSeeAnalytics && item('/tags', <IconTag size={21} stroke={2} />, 'Теги')}
          {canSeeAnalytics && item('/int-scorozvon', <IconPhone size={21} stroke={2} />, 'Скорозвон')}
          {isManager && !isAdmin && item('/admin/groups', <IconUsersGroup size={21} stroke={2} />, 'Группы')}

          {isAdmin && (
            <>
              <div className="main-sidebar-group">
                <span className="main-sidebar-group-label">Администрирование</span>
              </div>
              {item('/admin/stats',  <IconChartBar size={21} stroke={2} />,    'Обзор')}
              {item('/admin/users',  <IconUser size={21} stroke={2} />,         'Пользователи')}
              {item('/admin/groups', <IconUsersGroup size={21} stroke={2} />,   'Группы')}
              {item('/admin/board',           <IconLayoutKanban size={21} stroke={2} />, 'Борд')}
              {item('/admin/rules',           <IconListCheck size={21} stroke={2} />,    'Правила')}
              {item('/admin/lb-participants', <IconMedal size={21} stroke={2} />,        'Лидер борд')}
              {item('/admin/partners',         <IconUsersPlus size={21} stroke={2} />,   'Партнёры')}
              {item('/admin/providers',       <IconPlug size={21} stroke={2} />,         'Провайдеры')}
              {item('/admin/sms-templates',  <IconMessage size={21} stroke={2} />,       'SMS-шаблоны')}
              {item('/admin/themes',         <IconPalette size={21} stroke={2} />,       'Темы')}
            </>
          )}
        </nav>
      </aside>
    </>
  );
};

export { MainSidebar };
